import React, { useState, useEffect } from "react";
import DashboarderHeader from "../components/UserDashboarderHeader";
import DashboarderSidebar from "../components/UserDashboardSidebar";
import axios from "../api/axios";
import ReactPaginate from "react-paginate";
import "react-toastify/dist/ReactToastify.css";
import "react-tabs/style/react-tabs.css";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "../redux/store/actions/actionsTypes";
import UnsubscribeFlow from "./UnsubscribeForm";
import { Modal } from "react-bootstrap";
import Refresh from "../images/refresh.svg";
import { useNavigate } from "react-router-dom";
const dateOptions = {
  day: "2-digit",
  month: "long",
  year: "numeric",
};
function PlanHistory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [planData, setPlanData] = useState([]);
  const [invoiceHistory, setInvoiceHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [unsubscribeForm, setUnsubscribeForm] = useState({
    visible: false,
    subscriptionId: null,
  });

  const user_id = localStorage.getItem("user_id");
  const token = JSON.parse(localStorage.getItem("token"));

  useEffect(() => {
    getPlanHistory(currentPage);
  }, [currentPage]);

  const getPlanHistory = (page) => {
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    axios
      .post("/plan-history", { id: user_id, page }, config)
      .then((res) => {
        setPlanData(res.data.data.data[0]);
        setTotalPages(res.data.data.last_page);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getInvoiceHistory = async () => {
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      dispatch(startLoading());
      const response = await axios.get("invoice-list", config);
      setInvoiceHistory(response?.data?.data || []);
    } catch (error) {
      console.log("Error in fetching the invoices:", error);
      toast.error("Invoices Not found!!!");
    } finally {
      dispatch(stopLoading());
    }
  };
  useEffect(() => {
    getInvoiceHistory();
  }, []);

  const handleUnsubscribeFormClose = () => {
    setUnsubscribeForm({ visible: false, subscriptionId: null });
    dispatch(stopLoading());
    window.location.reload(true);
  };

  const handleManageSubscription = async (e) => {
    e.preventDefault();
    try {
      const config = {
        headers: {
          Authorization: "Bearer " + token,
        },
      };

      const response = await axios.get("/manage-subscription", config);
      if (response?.data?.url) {
        window.open(response.data.url, "_blank");
      } else {
        throw new Error("No billing portal URL returned from the server.");
      }
    } catch (error) {
      const errorMsg =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to open billing portal. Please try again later.";
      toast.error(errorMsg);
    }
  };

  return (
    <>
      <DashboarderHeader />
      <div className="MainContainer">
        <DashboarderSidebar />
        <div
          className="w-100 vh-100 position-fixed overlay d-none"
          id="sidebar-overlay"
        ></div>
        <main className="content-wrapper plan-history-wrapper">
          <div
            className="profile-div"
            style={{
              width: "100%",
              flex: "0.5",
              minHeight: "50%",
              margin: "0px",
            }}
          >
            <div
              className="login-inner affilate-link-div"
              style={{ padding: "30px", overflow: "auto", height: "100%" }}
            >
              <h3>Subscription Details</h3>
              {planData ? (
                <div>
                  <div className="header-subscription-info">
                    <span>
                      {planData?.plan?.name} Plan{" "}
                      {planData?.unsubscribe_at ? (
                        new Date(planData.valid_upto) < new Date() ? (
                          <span className="badge bg-danger">Cancelled</span>
                        ) : (
                          <span className="badge bg-success">
                            Active (until{" "}
                            {new Date(planData.valid_upto).toLocaleDateString()}
                            )
                          </span>
                        )
                      ) : planData?.payment_status === "pending" ? (
                        <span className="badge bg-secondary">Trial</span>
                      ) : (
                        <span className="badge bg-success">Active</span>
                      )}
                    </span>

                    {planData.unsubscribe_at ? (
                      <span>Cancelled At: {planData.unsubscribe_at} </span>
                    ) : (
                      <button
                        className="greenColor-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          setUnsubscribeForm({
                            visible: true,
                            subscriptionId: planData.id,
                          });
                        }}
                      >
                        Unsubscribe
                      </button>
                    )}
                  </div>
                  <div className="content-container">
                    <span>
                      {" "}
                      <b>Payment Status: </b>{" "}
                      <span
                        className={`${
                          planData?.payment_status === "pending"
                            ? "text-secondary"
                            : planData?.payment_status === "paid"
                            ? "text-success"
                            : "text-danger"
                        }`}
                        style={{ fontWeight: "600" }}
                      >
                        {planData?.payment_status?.toUpperCase()}
                      </span>
                    </span>
                    <span>
                      <b>Price: </b> €{planData?.plan?.price}
                    </span>
                    <span>
                      <b>Next Billing Details: </b>
                      {planData.unsubscribe_at
                        ? "Cancelled"
                        : new Date(planData?.valid_upto).toLocaleDateString(
                            "en-Gb",
                            dateOptions
                          )}
                    </span>
                    <span>
                      {planData?.unsubscribe_at && (
                        <a
                          href="#"
                          style={{ marginRight: "5px" }}
                          onClick={() => navigate("/subscribe")}
                          className="greenColor-btn"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Buy a new Subscription
                        </a>
                      )}
                      <a
                        href="#"
                        onClick={handleManageSubscription}
                        className="buy-now-btn"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Manage Your Subscription
                      </a>
                    </span>
                  </div>
                </div>
              ) : (
                <div>Please purchase a plan to view plan history.</div>
              )}
            </div>
          </div>

          <div
            className="profile-div"
            style={{ width: "100%", flex: "0.5", margin: "0px" }}
          >
            <div
              className="login-inner affilate-link-div"
              style={{ padding: "30px" }}
            >
              <h3>
                Invoices
                <img
                  className="refresh-img"
                  src={Refresh}
                  alt="img"
                  onClick={getInvoiceHistory}
                />
              </h3>
              <div className="table-responsive plan-history-overflow-div">
                <table className="table ">
                  <thead>
                    <tr>
                      <th>SR No</th>
                      <th>Invoice Number</th>
                      <th>Description</th>
                      <th>Price</th>
                      <th>Interval</th>
                      <th>Payment Status</th>
                      <th>Effective Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceHistory.length > 0 ? (
                      invoiceHistory
                        .filter((item) => item?.status != "draft")
                        .map((item, index) => (
                          <tr key={item.id}>
                            <td>{(currentPage - 1) * 10 + index + 1}</td>
                            <td>{item.number}</td>
                            <td>
                              {item.lines.data[0].description ??
                                "No Description"}
                            </td>
                            <td>€{(item.total / 100).toFixed(2)}</td>
                            <td>
                              {item.lines.data[0]?.plan?.interval.toUpperCase() ??
                                "N/A"}
                            </td>
                            <td>{item.status.toUpperCase()}</td>
                            <td>
                              {new Date(
                                item.effective_at * 1000
                              ).toLocaleDateString("en-GB", dateOptions)}
                            </td>
                            <td>
                              <a
                                href={item.hosted_invoice_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="buy-now-btn"
                              >
                                View Invoice
                              </a>
                            </td>
                          </tr>
                        ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
              /> */}
            </div>
          </div>
        </main>
        <Modal
          show={unsubscribeForm.visible}
          onHide={handleUnsubscribeFormClose}
        >
          <Modal.Body className="unsubscribe-modal">
            <UnsubscribeFlow
              subscriptionId={unsubscribeForm.subscriptionId}
              onClose={handleUnsubscribeFormClose}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default PlanHistory;
